import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { PreSelectedResourceInfo } from "../types/preSelectedResource";

interface PreSelectedResourceState {
  items: PreSelectedResourceInfo[] | null;
  itemProcessing: PreSelectedResourceInfo | null;
  isProcessingAlternativeResource: boolean;
  setIsProcessingAlternativeResource: (value: boolean) => void;
  removeItem: (item: PreSelectedResourceInfo) => void;
  clearItems: () => void;
  setItemProcessing: (item: PreSelectedResourceInfo) => void;
  clearItemProcessing: () => void;
  setItems: (items: PreSelectedResourceInfo[]) => void;
  addItem: (item: PreSelectedResourceInfo) => void;
  updateItem: (item: PreSelectedResourceInfo) => void;
}

export const usePreSelectedResourceStore = create<PreSelectedResourceState>()(
  devtools((set) => ({
    // items: [new PreSelectedResourceInfo({ type: EPreSelectedResource.ConflictOccurrence })],
    items: null,
    isProcessingAlternativeResource: false,
    setItems: (items: PreSelectedResourceInfo[]) => set(() => ({ items: items })),
    removeItem: (item: PreSelectedResourceInfo) =>
      set((state) => ({ items: state.items?.filter((i) => i.id !== item.id) ?? null })),
    clearItems: () => set({ items: null }),
    addItem: (item: PreSelectedResourceInfo) => set((state) => {
      const itemClone = [...state.items ?? []];
      itemClone.push(item);
      return { items: itemClone };
    }),
    setIsProcessingAlternativeResource: (value: boolean) => set({ isProcessingAlternativeResource: value }),
    setItemProcessing: (item: PreSelectedResourceInfo) => set({ itemProcessing: item }),
    clearItemProcessing: () => set({ itemProcessing: null }),
    updateItem: (item: PreSelectedResourceInfo) => set((state) => {
      const itemClone = [...state.items ?? []];
      const index = itemClone.findIndex((i) => i.id === item.id);
      if(index !== -1) {
        itemClone[index] = item;
      }
      return { items: itemClone };
    }),
  }), { name: "preSelectedResourceStore" })
);
